var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('topNav'),_c('sideBar'),_c('div',{staticClass:"routerBox"},[_c('router-view')],1),_c('pcFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }